import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { useApi } from '@fortem-monorepo/react-spa'
import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface TopLevelBucketFormFieldProps {}

export const TopLevelBucketFormField: React.FC<TopLevelBucketFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ top_level_bucket_id: number | null }>()

  const api = useApi()

  const query = useQuery({
    queryKey: ['static/buckets/top-level'],
    queryFn: () => api.buckets.getTopLevelBuckets(),
  })

  const topLevelBuckets = useMemo(() => {
    return (query.data ?? [])
      .map((item) => ({
        label: item.label,
        value: item.value?.toString(),
      }))
      .filter((v) => v.value)
  }, [query.data])

  return (
    <FormField
      name="top_level_bucket_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Top Level Bucket</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              showNone="None"
              placeholder={'Select a Top Level Bucket'}
              value={field.value?.toString()}
              setValue={(val) =>
                setValue('top_level_bucket_id', val ? parseInt(val) : null, {
                  shouldValidate: true,
                })
              }
              options={topLevelBuckets}
            />
          </FormItem>
        )
      }}
    />
  )
}
